import * as I18n from '../../types/i18n';

export const i18nMapping = new Map<I18n.AvailableLanguagesKey, I18n.AvailableLanguagesI18nKey>([
  ['fr', 'fr-FR'],
  ['es', 'es-LA'],
  ['pt-br', 'pt-BR'],
  ['sv', 'sv-SE'],
  ['it', 'it-IT'],
  ['pl', 'pl-PL'],
]);

export const templateMapping = new Map<I18n.AvailableLanguagesI18nKey, I18n.AvailableLanguagesKey>([
  ['fr-FR', 'fr'],
  ['es-LA', 'es'],
  ['pt-BR', 'pt-br'],
  ['sv-SE', 'sv'],
  ['it-IT', 'it'],
  ['pl-PL', 'pl'],
]);

export const i18nLanguageMapping = new Map<string, string>([
  ['fr', 'fr-FR'],
  ['es', 'es-LA'],
  ['pt-br', 'pt-BR'],
  ['sv', 'sv-SE'],
  ['it', 'it-IT'],
  ['pl', 'pl-PL'],
]);

export const templateLanguageMapping = new Map<string, string>([
  ['fr-FR', 'fr'],
  ['es-LA', 'es'],
  ['pt-BR', 'pt-br'],
  ['sv-SE', 'sv'],
  ['it-IT', 'it'],
  ['pl-PL', 'pl'],
]);

const languageMapping = {
  i18n: i18nMapping,
  template: templateMapping,
};

export default languageMapping;
